<template>
  <div
    v-if="webcamInit"
    :class="[opening? 'open':'','webcamDiv',onside? '':'notonside',fixed? 'fixed':'']"
  >
    <div
      v-if="onside"
      class="touchBar"
      @click="opening =! opening"
    >
      <span>影像紀錄</span>
    </div>
    <div class="webcam-wrap">
      <div v-if="onside">
        <span>WebCam鏡頭</span>
        <el-button
          id="getPictureButton"
          size="mini"
          round
          @click="getPicture"
        >
          手動拍照 (F8)
        </el-button>
      </div>
      <div
        v-else
        class="webcam-wrap-notonside"
      >
        <span>WebCam鏡頭</span>
        <el-button
          id="getPictureButton"
          size="mini"
          round
          @click="getPicture"
        >
          手動拍照
        </el-button>
      </div>
      <div :class="[noWebcam?'noWebcam':'','webcam']">
        <div ref="webcam" />
      </div>
    </div>
    <div class="pic-wrap">
      <span>影像擷取</span>
      <div
        class="pic"
        :style="`background-image: url(${pic})`"
      />
    </div>
  </div>
</template>

<script>
import '../js/utils/webcam.js'
export default {
  props: {
    fixed: false,
    onside: Boolean,
    webCamSize: Object
  },
  data () {
    return {
      webcamInit: false,
      noWebcam: false,
      opening: false,
      pic: '',
      controlWebCamSize: {
        w: 230,
        h: 150
      }
    }
  },
  mounted () {
    // eslint-disable-next-line eqeqeq
    if (this.onside == false) {
      this.opening = true
    } else {
      this.opening = false
    }
    console.log(this.webCamSize)
    if (this.webCamSize !== undefined) { this.controlWebCamSize = this.webCamSize }
  },
  methods: {
    init () {
      return new Promise((resolve, reject) => {
        this.checkWebCamHardware(2).then((res) => {
          if (!res) {
            this.webcamInit = true
            this.noWebcam = true
            if (localStorage.getItem('camreaNeverTips')) {
              resolve('未開啟攝影機')
              return false
            }
            this.$alert('偵測不到攝影機，請先確認是否連接，不然會沒有影像紀錄喔！<br><br><input type="checkbox" id="camreaNeverTips">不再顯示', '', {
              confirmButtonText: '確定',
              dangerouslyUseHTMLString: true,
              callback: () => {
                resolve('未開啟攝影機')
                if (document.getElementById('camreaNeverTips').checked) {
                  localStorage.setItem('camreaNeverTips', true)
                }
              }
            })
            return false
          }
          this.webcamInit = true
          this.$nextTick(() => {
            Webcam.reset()
            Webcam.set({
              width: this.controlWebCamSize.w,
              height: this.controlWebCamSize.h,
              image_format: 'png',
              jpeg_quality: 90,
              success: () => {
                window.addEventListener('keydown', this.keyinF8Takepic)
                resolve()
              },
              error: () => {
                reject()
                this.$alert('攝影機初始化失敗，請在重新嘗試一次。', '', {
                  confirmButtonText: '確定',
                  callback: () => {}
                })
              }
            })
            Webcam.attach(this.$refs.webcam)
          })
        }, (err) => {
          reject()
          this.webcamInit = true
          this.noWebcam = true
          this.$alert(err, '', {
            confirmButtonText: '確定',
            callback: () => {}
          })
        })
      })
    },
    getPicture () {
      if (this.noWebcam || !this.webcamInit) {
        return false
      }
      Webcam.snap(url => {
        this.pic = url
        this.$emit('takephoto', url)
      })
      document.getElementById('getPictureButton').blur()
    },
    closeWebcam () {
      Webcam.reset()
      this.webcamInit = false
      this.noWebcam = false
      this.opening = false
      this.pic = ''
      window.removeEventListener('keydown', this.keyinF8Takepic)
    },
    // 偵測是有有WebCam
    checkWebCamHardware (checkMaxTimes, checkTimes) {
      const self = this
      return new Promise(function (resolve, reject) {
        checkTimes = checkTimes || 1
        navigator.getUserMedia = (navigator.getUserMedia ||
          navigator.webkitGetUserMedia ||
          navigator.mozGetUserMedia ||
          navigator.msGetUserMedia)
        if (navigator.getUserMedia) {
          const checkPackeg = function (status) {
            if (status) {
              resolve(true)
            }
            if (checkTimes >= checkMaxTimes) {
              resolve(false)
            } else {
              setTimeout(function () {
                self.checkWebCamHardware(checkMaxTimes, checkTimes + 1).then(function (callback) {
                  resolve(callback)
                })
              }, 1000)
            }
          }

          navigator.getUserMedia({
            video: true
          }, function (stream) {
            stream.getVideoTracks().some(function (track) {
              checkPackeg(track.enabled)
            })
          }, function (e) {
            checkPackeg(false)
          })
        } else {
          reject('瀏覽器不支援webcam')
        }
      })
    },
    keyinF8Takepic (eve) {
      // eslint-disable-next-line eqeqeq
      if (eve.keyCode == 119 && this.webcamInit) {
        this.getPicture()
      }
    }
  }
}
</script>

<style lang="sass" scoped>
  .webcamDiv
    background-color: $white
    width: 260px
    padding-bottom: 15px
    transition: right ease-out 400ms
    &.fixed
      position: fixed
      z-index: 20001
      top: 200px
      right: -260px
    &.open
      right: 0
      box-shadow: -1px 3px 7px 1px #cdcdcd
    .touchBar
      position: absolute
      top: 0
      left: -50px
      width: 30px
      padding: 5px 10px
      font-size: 17px
      font-weight: bold
      text-align: center
      background-color: #e8e8e8
      background-image: none
      border-radius: 4px 0 0 4px
      box-shadow: -3px 3px 6px -2px $borderDark1
      cursor: pointer
      writing-mode: vertical-lr
      letter-spacing: 5px
    .webcam-wrap,.pic-wrap
      margin: 10px 0
      padding: 0px 15px 0
      text-align: left
      span
        color: $mainFontColor
        font-size: 16px
        margin-right: 5px
        display: inline-block
      .webcam,.pic
        width: 230px
        height: 150px
        border: 1px solid $borderDark1
        border-radius: 8px
        margin-top: 10px
        // margin-bottom: 10px
      .webcam
        &.noWebcam
          background-image: url('../assets/img/Webcam/non-webcam.jpg')
  .notonside
    transition: none
    &.fixed
      position: relative
      z-index: 0
      top: 0px
      max-width: 260px
      margin: 0px auto
    &.open
      right: 0
      box-shadow: none
    .webcam-wrap-notonside
      position: relative
      span
        line-height: 32px
      button
        position: absolute
        right: 0
</style>
